import { CarvanaTheme } from '@carvana/theme';
import styled from 'styled-components';

export const TitleWrapper = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
  align-items: center;

  & > h2 {
    width: 410px;
    margin-top: 15px;
    font-size: 36px;
    font-weight: bold;
    color: #183558;
    line-height: 40px;
  }

  @media (max-width: ${CarvanaTheme.breakpoints.values.md}px) {
    & > h2 {
      // width: 195px;
      font-size: 28px;
      font-weight: bold;
      line-height: 32px;
    }
  }

  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    & > h2 {
      width: 200px;
      font-size: 24px;
      font-weight: bold;
      line-height: 28px;
    }
  }
`;

export const HeaderWrapper = styled.div`
  color: #183558;
  text-align: center;
`;

export const Header = styled.h1`
  font-weight: bold;
  font-size: calc(40px + (70 - 40) * ((100vw - 300px) / (1600 - 300)));
  line-height: 90%;
  max-width: 85%;
  text-transform: uppercase;
  margin: 0px auto auto auto;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    max-width: 70%;
  }

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    max-width: 60%;
  }
`;

export const HeaderSubText = styled.p`
  font-size: calc(13px + (24 - 14) * ((100vw - 300px) / (1600 - 300)));
  margin: 24px auto;
  width: 300px;
  font-size: 13px;
  line-height: 20px;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    font-size: 18px;
    line-height: 32px;
    width: 500px;
    margin: 34px auto;
  }

  @media (min-width: ${CarvanaTheme.breakpoints.values.md}px) {
    font-size: 24px;
    line-height: 32px;
    width: 700px;
    margin: 40px auto;
  }
`;

export const HeaderSubTextBold = styled(HeaderSubText)`
  font-weight: 800;
  color: #183558;
  text-transform: uppercase;
  @media (min-width: ${CarvanaTheme.breakpoints.values.xs}px) {
    margin: 10px auto;
  }
`;

export const VendingContainer = styled.div`
  background-color: #f4f8fa;
`;

export const LocationContainer = styled.div`
  background-color: white;
  padding-top: 40px;
`;
